var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgKikiMsg = function SvgKikiMsg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h20v20H0z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3 4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.933 0h12.134c.515 0 .933.418.933.933v7.734a.933.933 0 0 1-.933.933H3.79a1.4 1.4 0 0 0-.817.263L.37 11.734a.233.233 0 0 1-.37-.189V.933C0 .418.418 0 .933 0Z",
    stroke: "currentColor",
    strokeWidth: 1.575
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "currentColor",
    cx: 3.733,
    cy: 4.8,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "currentColor",
    cx: 7,
    cy: 4.8,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "currentColor",
    cx: 10.267,
    cy: 4.8,
    r: 1
  })))));
};
export default SvgKikiMsg;